import React from "react"
import { Link } from "react-router-dom"
import Alert from "~/ui-rtk/components/ui/common/Alert"

interface ConnectorUpdateAlertProps {
  hasUpdates: boolean
  updateCount: number
  connectorsNeedingUpdate: Array<{
    id: string
    name: string
    categories: string[]
  }>
  recommendedCategory?: string
}

const ConnectorUpdateAlert: React.FC<ConnectorUpdateAlertProps> = ({
  hasUpdates,
  updateCount,
  connectorsNeedingUpdate,
  recommendedCategory,
}) => {
  if (!hasUpdates) {
    return null
  }

  const isSingleConnector = updateCount === 1
  const firstConnector = connectorsNeedingUpdate[0]

  const title = isSingleConnector
    ? `🚀 ${firstConnector?.name} Update Ready`
    : "🚀 Connector Updates Ready"

  const message = isSingleConnector
    ? `Your ${firstConnector?.name} connector has a new version with enhanced data collection, improved accuracy, and new features. Upgrade now to unlock the latest capabilities and ensure you're getting the most comprehensive data insights.`
    : "Multiple connectors have new versions with enhanced data collection, improved accuracy, and new features. Upgrade all connectors to unlock the latest capabilities and ensure you're getting the most comprehensive data insights across all your connected platforms."

  return (
    <div className="p-4">
      <Alert
        title={title}
        content={
          <div className="no-underline">
            <span>{message} </span>
            <br />
            <Link
              to={`/setup/connectors${recommendedCategory ? `?category=${encodeURIComponent(recommendedCategory)}` : ""}`}
              className="text-blue-400 hover:text-blue-300 no-underline font-medium"
            >
              <span className="no-underline font-bold">
                ✨ Upgrade Now - Unlock New Features
              </span>
            </Link>
          </div>
        }
        variant="danger"
        injectable={false}
      />
    </div>
  )
}

export default ConnectorUpdateAlert
